<template>
  <!-- 渠道建设计划 -->
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
      :span-method="objectSpanMethod"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 类型 -->
      <el-table-column
        prop="outletsType"
        label="类型"
        min-width="170px"
        align="center"
        class-name="disabled_column"
      />
      <!-- 类别 -->
      <el-table-column
        prop="operationType"
        label="类别"
        min-width="170px"
        align="center"
        class-name="disabled_column"
      />
      <!-- 渠道计划 -->
      <el-table-column label="渠道计划" align="center">
        <!-- 计划 -->
        <el-table-column
          prop="plan"
          label="计划"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                !(scope.$index === 2 || scope.$index === 5) &&
                  editField === 'plan' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.plan"
              class="number_input"
              :controls="false"
              :precision="2"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <div v-else>
              {{
                scope.$index === 2 || scope.$index === 5
                  ? getTotal(scope.$index, "plan")
                  : scope.row.plan
              }}
            </div>
          </template>
        </el-table-column>
        <!-- 已完成 -->
        <el-table-column
          prop="completed"
          label="已完成"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                !(scope.$index === 2 || scope.$index === 5) &&
                  editField === 'completed' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.completed"
              class="number_input"
              :controls="false"
              :precision="2"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <div v-else>
              {{
                scope.$index === 2 || scope.$index === 5
                  ? getTotal(scope.$index, "completed")
                  : scope.row.completed
              }}
            </div>
          </template>
        </el-table-column>
        <!-- 待完成 -->
        <el-table-column
          prop="unfinished"
          label="待完成"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                !(scope.$index === 2 || scope.$index === 5) &&
                  editField === 'unfinished' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.unfinished"
              class="number_input"
              :controls="false"
              :precision="2"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <div v-else>
              {{
                scope.$index === 2 || scope.$index === 5
                  ? getTotal(scope.$index, "unfinished")
                  : scope.row.unfinished
              }}
            </div>
          </template>
        </el-table-column>
        <!-- 建设计划 -->
        <el-table-column
          prop="buildPlan"
          label="建设计划"
          min-width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                !(scope.$index === 2 || scope.$index === 5) &&
                  editField === 'buildPlan' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.buildPlan"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{
                scope.$index === 2 || scope.$index === 5
                  ? "-"
                  : scope.row.buildPlan
              }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 渠道评价 -->
      <el-table-column label="渠道评价" align="center">
        <!-- 盈利能力评价 -->
        <el-table-column
          prop="profitabilityEvaluation"
          label="盈利能力评价"
          min-width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                !(scope.$index === 2 || scope.$index === 5) &&
                  editField === 'profitabilityEvaluation' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.profitabilityEvaluation"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{
                scope.$index === 2 || scope.$index === 5
                  ? "-"
                  : scope.row.profitabilityEvaluation
              }}
            </div>
          </template>
        </el-table-column>
        <!-- 销售目标达成评价 -->
        <el-table-column
          prop="saleEvaluation"
          label="销售目标达成评价"
          min-width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                !(scope.$index === 2 || scope.$index === 5) &&
                  editField === 'saleEvaluation' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.saleEvaluation"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{
                scope.$index === 2 || scope.$index === 5
                  ? "-"
                  : scope.row.saleEvaluation
              }}
            </div>
          </template>
        </el-table-column>
        <!-- 促销活动效果评价 -->
        <el-table-column
          prop="promotionEvaluation"
          label="促销活动效果评价"
          min-width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                !(scope.$index === 2 || scope.$index === 5) &&
                  editField === 'promotionEvaluation' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.promotionEvaluation"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{
                scope.$index === 2 || scope.$index === 5
                  ? "-"
                  : scope.row.promotionEvaluation
              }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              !(scope.$index === 2 || scope.$index === 5) &&
                editField === 'remark' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{
              scope.$index === 2 || scope.$index === 5 ? "-" : scope.row.remark
            }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateChannelConstructionPlanApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [], // 表格数据
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.property === "outletsType") {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 获取合计
    getTotal(index, field) {
      this.tableData[index][field] =
        (this.tableData[index - 2][field] ?? 0) +
        (this.tableData[index - 1][field] ?? 0);
      return this.tableData[index][field];
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
      // 禁用
      if (rowIndex === 2 || rowIndex === 5) {
        if (
          columnIndex === 2 ||
          columnIndex === 3 ||
          columnIndex === 4 ||
          columnIndex === 5
        ) {
          return "total_column";
        }
        return "disabled_column";
      }
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateChannelConstructionPlanApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data || [];
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
